// src/components/NotFound/index.js
import React, { Component } from 'react';
import AdminHeader from '../AdminHeader';
import Auth from '../../service/auth';
var BaseService = require('../../service/baseservice');
import FlatButton from 'material-ui/FlatButton';
import {Tabs, Tab} from 'material-ui/Tabs';
import LoadingIndicator from '../shared/LoadingIndicator';
import IndustryRow from './IndustryRow';
import IndustryLetterTab from './IndustryLetterTab';
import IndustryEditDialog from './IndustryEditDialog';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';

var newIndustry = {
  _id: "",
  name: "",
  searchTerms:""
};

export default class IndustriesPage extends Component {

  state = {
    dialogOpen: false,
    industry: newIndustry,
    industryIndex: -1,
    selectedLetter: 'A',
    industries: []
  };

  dataUpdated(data) {
    this.industriesFetched(data.industries);
  }

  componentDidMount() {
    BaseService.addListener(this.dataUpdated.bind(this));

    if (BaseService.fetchedData.industries.length > 0) {
        this.industriesFetched(BaseService.fetchedData.industries);
    }
  }

  industriesFetched(industries) {
    var letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "Å", "Ä", "Ö"];

    var dataDictionary = {};
    for (let letter in letters) {
      if (letter != null) {
        dataDictionary[letters[letter]] = [];
      }
    }

    for (var industryIdx in industries) {
      if (industries[industryIdx] != null) {
        var industry = industries[industryIdx];
        let char = industry.name.charAt(0);
        char = char.toUpperCase();

        let array = dataDictionary[char];
        array.push(industry);
        dataDictionary[char] = array;
      }
    }

    this.setState({ industries : dataDictionary });
  }

  handleClose = () => {
    this.setState({ dialogOpen: false });
  };

  handleSaveChanges = () => {
    this.setState({ dialogOpen: false });
  }

  onIndustrySelected(selected) {
    let newState = {
      dialogOpen: true,
      industryIndex: selected,
      industry: this.state.industries[this.state.selectedLetter][selected]
    };

    this.setState(newState);
  }

  onTabSelected(letter) {
    this.setState({ selectedLetter: letter });
  }

  createNewClicked() {
    this.setState({ dialogOpen:true, industry: newIndustry })
  }

  render() {
    var content = <LoadingIndicator/>;

    if (BaseService.fetchedData.industries.length > 0) {
      var dataDictionary = this.state.industries;
      var tabs = Object.keys(dataDictionary).map(letter => {
          var industries = dataDictionary[letter];
          var rows = industries.map( (industry, index) => {
            return <IndustryRow key={industry._id} industry={industry} onIndustrySelected={(index) => this.onIndustrySelected(index)}/>
          });

          var tabContent = "";
          if (this.state.selectedLetter === letter) {
            tabContent = <IndustryLetterTab key={letter} letter={letter} onRowSelection={(row) => this.onIndustrySelected(row)} rows={rows}/>
          }

          return (
            <Tab key={letter} label={letter} value={letter}>
              {tabContent}
            </Tab>);
          });

          content =
              <Tabs style={{marginTop: '20px'}} value={this.state.selectedLetter} onChange={(selectedTab) => this.onTabSelected(selectedTab)}>
                  {tabs}
                </Tabs>;
        }

    return (
      <div>
        <AdminHeader selected="industries"/>
          <Toolbar style={{backgroundColor: 'white', borderBottom: '1px rgba(232, 232, 232, 1) solid'}}>
            <ToolbarGroup>
                <FlatButton label="Luo uusi toimiala" onTouchTap={() => this.createNewClicked()} style={{marginLeft:"10px"}} primary={true}/>
            </ToolbarGroup>
          </Toolbar>
        <div className="main-container">
          {content}
        </div>
        <IndustryEditDialog
          enabled={this.state.dialogOpen}
          handleClose={() => this.handleClose()}
          industry={this.state.industry}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IndustriesPage/IndustriesPage.js